import React from "react";
import { useApp } from "@/context/AppContext";

export function LangToggle({ className = "" }) {
  const { lang, toggleLang } = useApp();
  return (
    <button
      data-testid="language-toggle-button"
      onClick={toggleLang}
      className={`font-mono-cu text-[0.7rem] tracking-[0.2em] text-[color:var(--cu-muted)] hover:text-[color:var(--cu-gold-light)] transition-colors ${className}`}
      aria-label="Toggle language"
    >
      <span className={lang === "en" ? "gold-text" : ""}>EN</span>
      <span className="mx-1.5 opacity-40">/</span>
      <span className={lang === "it" ? "gold-text" : ""}>IT</span>
    </button>
  );
}
